import React, { useEffect, useState, Fragment } from "react";
import { useTranslation } from 'react-i18next';
import { NavLink, useNavigate } from 'react-router-dom';
import { Row, Col, CardBody, Card } from "reactstrap";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader";
import DataTable from 'react-data-table-component';
import DiscountCouponService from "../DiscountCoupon/Discountcoupons.service";
import AuthService from "../Authentication/auth.service";
import Alerts from "../../components/Alerts/alerts";
import { Tooltip } from "@mui/material";
import DiscountCouponsFilter from "../../components/Table Filters/WithDrawlRequestFilter.js";
import PermissionAccess from '../../PermissionAccess/Access.js';
import LedgerDetailTable from './LedgerDetailTable .js';
import moment from "moment";

const DiscountcouponsList = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [discountcoupons, setDiscountcoupons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterStatus, setFilterStatus] = useState('');
  const [withDrawlCount, setWithDrawlCount] = useState(0);
  const [selectedId, setSelectedId] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedDoctorId, setSelectedDoctorId] = useState(null);
  const [withDrawlID, setwithDrawlID] = useState(null);
  const [selectedDoctorName, setSelectedDoctorName] = useState("");
  const [totalRequestedAmount, setTotalRequestedAmount] = useState(0);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedUpdatedAt, setSelectedUpdatedAt] = useState("");
  const [selectedRejectionReason, setSelectedRejectionReason] = useState("");

  const [pageLimit, setPageLimit] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();

  const [showModalAddDiscountCoupon, setShowModalAddDiscountCoupon] = useState(false);
  const handleToggleModalAddDiscountCoupon = () => {
    setShowModalAddDiscountCoupon(!showModalAddDiscountCoupon);
  }

  const [showModalEditDiscountCoupon, setShowModalEditDiscountCoupon] = useState(false);
  const handleToggleModalEditDiscountCoupon = (id) => {
    setShowModalEditDiscountCoupon(!showModalEditDiscountCoupon);
    setSelectedId(id); // Set the selected ID when toggling modal
  };

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    fetchDiscountcoupons(0, pageLimit);
  }, [pageLimit]);


  function fetchDiscountcoupons(page_index, page_limit, status) {
    setLoading(true);
    var offset = (page_index - 1) * page_limit;
    if (offset < 1) {
      offset = 0;
    }

    
    DiscountCouponService.getAllWithdrawlRequest(authData.sessionID,offset, page_limit, status).then(
      (response) => {
        setLoading(false);
        console.log("Get discountcoupons response:-", response);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          console.log(response.data);
          setDiscountcoupons(response.data.data);
          setTotalRows(response.data.count.count);
        }
      },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
        if (errContent) {
          Alerts.swalErrorAlert(errContent);
        } else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."));
        }
      }
    );
  }




  

  

  const mycolumns = [
    {
        name: t('Date'),
        selector: row =>
          moment(row.datetime_added).format("DD MMMM YYYY, hh:mm A"),
        width: "20%",
        sortable: true,
      },
    {
      name: t('Doctor Name'),
      selector: row => row.doctor_details?.full_name || "-",
      width: "20%",
      sortable: true,
    },

    {
  name: t('Requested Amount'),
    selector: row => `RM ${row.requested_amount?.toFixed(2) || "0.00"}`,
    width: "20%",
    sortable: true,
    },

    {
  name: t('Status'),
  width: '20%',
  selector: (row) => {
    let btnClass = "";
    let bgColor = "";
    let borderColor = "";

    if (row.status === "Paid") {
      btnClass = "btn-success";
      bgColor = "#1BD35A";
      borderColor = "#3ac47d";
    } else if (row.status === "Rejected") {
      btnClass = "btn-warning";
      bgColor = "#FFA500"; // orange
      borderColor = "#FFA500";
    } else {
      // Pending
      btnClass = "btn-danger";
      bgColor = "red";
      borderColor = "#FF0000";
    }

    return (
      <button
        type="button"
        className={`btn btn-sm ${btnClass} btn-hover-shine me-3`}
        style={{ backgroundColor: bgColor, borderColor }}
      >
        {row.status}
      </button>
    );
  },
  sortable: true,
},


    {
  name: t('Actions'),
  width: "20%",
  cell: (row) => (
    <Tooltip
      placement="top"
      title={`${t("Request")} ${t("Action")}`}
      arrow
      style={{ cursor: "pointer" }}
      onClick={() => {
        setSelectedDoctorId(row.doctor_id);
        setSelectedDoctorName(row.doctor_details?.full_name || "-");
        setTotalRequestedAmount(row.requested_amount || 0);
        setSelectedStatus(row.status); // ⬅️ NEW
        setSelectedUpdatedAt(row.updated_at); // ⬅️ NEW
        setSelectedRejectionReason(row.rejection_reason || "");
        setShowDetailModal(true);
        setwithDrawlID(row._id);
      }}
    >
      <i className="pe-7s-look btn-icon-wrapper text-info fs-5 p-1"></i>
    </Tooltip>
  )
}


  ];



  const handleSearch = (status) => {
    setFilterStatus(status);
    if (status !== '') {
      fetchDiscountcoupons(0, pageLimit, status)
    }
  };

  const handleClear = () => {
    setFilterStatus('');
    fetchDiscountcoupons(0, pageLimit);
  };
  const filteredItems = discountcoupons;


 

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <DiscountCouponsFilter
        onSearch={handleSearch}
        onClear={handleClear}
        filterStatus={filterStatus}
      />
    );
  }, [filterStatus]);


  function handlePageChange(page_index) {
    console.log("Page index:-", page_index)
    setCurrentPage(page_index)
    fetchDiscountcoupons(page_index, pageLimit, filterStatus);
  }

  async function handlePerRowsChange(newPageLimit, page_index) {
    setPageLimit(newPageLimit);
  }

  return (
    <Fragment>

      <div className="app-main__outer">
        <div className="app-main__inner">
          <div className="bg-light-gray bg-animation">
            <div className="d-flex justify-content-center align-items-center">
              <Col md="12" className="mx-auto app-login-box">
                <div className="app-page-title">
                  <div className="page-title-wrapper">
                    <div className="page-title-heading fw-bold">
                      <div className="page-title-icon">
                        <i className="pe-7s-news-paper icon-gradient bg-tempting-azure" />
                      </div>
                      <div>
                        {`${t("Withdrawl Requests")} ${t("Management")}`}
                        <div className="page-title-subheading">
                          {`${t("Withdrawl Requests List")}`}
                        </div>
                      </div>
                    </div>
                    <div className="page-title-actions">

                      <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-success btn-hover-shine me-3">
                        {t("Back")}
                      </button>

                    </div>
                  </div>
                </div>
                <Row>
                  <LoadingOverlay
                    tag="div"
                    active={loading}
                    styles={{ overlay: (base) => ({ ...base }) }}
                    spinner={<DNALoader />}
                  >
                    <Col md="12">
                      <Card className="main-card mb-3">
                        <CardBody>
                          <Col md="6" style={{ float: "left", position: "absolute", zIndex: "1" }}>
                            {subHeaderComponentMemo}
                          </Col>
                          <DataTable
                            data={filteredItems}
                            columns={mycolumns}
                            pagination
                            fixedHeader
                            fixedHeaderScrollHeight="400px"
                            subHeader
                            subHeaderComponent={
                              <div>
                                  
                              </div>
                            }

                            paginationServer
                            paginationTotalRows={totalRows}
                            onChangePage={handlePageChange}
                            onChangeRowsPerPage={handlePerRowsChange}
                            paginationResetDefaultPage={resetPaginationToggle}
                          />
                        </CardBody>
                      </Card>
                    </Col>
                  </LoadingOverlay>
                </Row>
              </Col>
            </div>
          </div>
        </div>
      </div>

     {showDetailModal && (
        <div className="modal d-block" tabIndex="-1" role="dialog" style={{ background: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
                <div className="modal-header position-relative">
                  <h5 className="modal-title fw-bold">
                    {t('Ledger Details for')} {selectedDoctorName}
                  </h5>

                  <button
                    type="button"
                    className="btn-close position-absolute"
                    style={{ top: '1rem', right: '1rem' }}
                    onClick={() => setShowDetailModal(false)}
                  ></button>
                </div>

                <div className="modal-body">
                <LedgerDetailTable
                  doctorId={selectedDoctorId}
                  status={selectedStatus}
                  updatedAt={selectedUpdatedAt}
                  rejectionReason={selectedRejectionReason}
                  doctorName={selectedDoctorName}                      // ✅ new
                  requestedAmount={totalRequestedAmount}               // ✅ new
                  onClose={() => setShowDetailModal(false)} 
                  refreshList={() => fetchDiscountcoupons(currentPage || 0, pageLimit, filterStatus)}
                  withDrawlID={withDrawlID}
                />
                </div>
            </div>
            </div>
        </div>
        )}



    </Fragment>
  );
};

export default DiscountcouponsList;
